import React, { Component } from 'react';
import ReCaptchaContainer from '../recaptcha/ReCaptchaContainer';
import { DebounceInput } from 'react-debounce-input';
import WorkflowNavContainer from '../workflow-navigation/WorkflowNavContainer';
import PropTypes from 'prop-types';

const propTypes = {
    reCaptchaPublicKey: PropTypes.string.isRequired,
    reCaptchaOnloadCallbackName: PropTypes.string.isRequired,
    reCaptchaDisabled: PropTypes.bool.isRequired,
    workflowNavElementId: PropTypes.string
};

const defaultProps = {
    reCaptchaDisabled: false
};

class ForgotUsernameContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailIsValid: false,
            reCaptchaIsValid: false
        };
        this.handleReCaptchaChange = this.handleReCaptchaChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
    }

    handleReCaptchaChange() {
        this.setState({ reCaptchaIsValid: true });
    }

    handleEmailChange(event) {
        this.setState({ emailIsValid: event.target.checkValidity() });
    }

    isNextEnabled() {
        if (this.props.reCaptchaDisabled) {
            return this.state.emailIsValid;
        }
        return this.state.emailIsValid && this.state.reCaptchaIsValid;
    }

    render() {
        var reCaptchaComponent = this.props.reCaptchaDisabled ? null : (
            <ReCaptchaContainer
                reCaptchaPublicKey={this.props.reCaptchaPublicKey}
                onloadCallbackName={this.props.reCaptchaOnloadCallbackName}
                verifyCallback={this.handleReCaptchaChange}
            />
        );

        return (
            <div>
                <div className="asc-form-group">
                    <label className="asc-form-label" htmlFor="email">
                        Email Address
                    </label>
                    <DebounceInput
                        className="asc-form-input"
                        onChange={this.handleEmailChange}
                        debounceTimeout={700}
                        type="email"
                        name="email"
                        placeholder="name@example.com"
                        required
                    />
                </div>
                {reCaptchaComponent}
                <WorkflowNavContainer
                    primaryButtonText="Submit"
                    primaryButtonSubmitEnabled={this.isNextEnabled()}
                    primaryButtonCaret={false}
                    elementId={this.props.workflowNavElementId}
                />
            </div>
        );
    }
}

ForgotUsernameContainer.propTypes = propTypes;
ForgotUsernameContainer.defaultProps = defaultProps;
export default ForgotUsernameContainer;
